import { THEME } from "./theme";
import { Environment } from "./types";

export const environment: Environment = {
    production: true,
    defaultLanguage: THEME.id === 'dyo' ? 'tr' : 'en',
    cookieDomain: 'localhost',
    theme: THEME,
};
